import React, { useEffect, useState } from 'react'

import { Button, Card, Form, Icon, notification, Row, Typography } from 'antd'
import { Formik } from 'formik'
import { get } from 'lodash'
import * as yup from 'yup'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import CustomInput from '../../components/CustomInput/customInput'
import CustomSwitch from '../../components/CustomSwitch/customSwitch'
import CustomSelect from '../../components/CustomSelect/customSelect'
import { RULES, validRule } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const CreateDistrict = function ({ match, history }) {
  const defaultFormValues = { active: true }
  const [formLayout] = useState('vertical')

  // Params url
  const { id } = match.params

  // Form configuration
  const [formValues, setFormValues] = useState({})
  const [listRegions, setListRegions] = useState([])

  const form = {
    initialValues: formValues,
    yupValidationCreate: yup.object().shape({
      // Create-validation-rules-body-marker
      regionId: yup.string().typeError(getMessage('shouldSelectAValue')).required(getMessage('selectTheRegion')),
      name: yup
        .string()
        .max(60)
        .typeError('must be string')
        .required(getMessage('isRequired', getMessage('districtName')))
    }),

    yupValidationUpdate: yup.object().shape({
      // Update-validation-rules-body-marker
      regionId: yup.string().typeError(getMessage('shouldSelectAValue')).required(getMessage('selectTheRegion')),
      name: yup.string().max(60).typeError('must be string')
    }),

    onSubmit: async (values) => {
      console.tron.log('submit values', values)

      let formattedValues = {
        name: get(values, 'name'),
        regionId: Number(get(values, 'regionId')),
        active: get(values, 'active')
      }
      if (!id) {
        const data = { ...formattedValues }
        storeDistrict(data)
      } else {
        const payload = {
          data: {
            name: formValues.name,
            regionId: formValues.regionId,
            active: formValues.active
          },
          id
        }

        for (const key in payload.data) {
          if (payload.data[key] === null) {
            delete payload.data[key]
          }
        }

        updateDistrict(payload)
      }
    }
  }

  // Mount/Umount component
  useEffect(() => {
    const hasAccess = validRule(RULES.DISTRICT) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }

    retrieveRegions({ active: true })

    if (id) {
      retrieveDistrict(id)
    } else {
      setFormValues({})
    }

    // Use-effect-mount-marker

    return () => {
      setFormValues({})
    }
  }, [])

  useEffect(() => {
    if (!id) {
      setFormValues(defaultFormValues)
    }
  }, [id])

  async function retrieveRegions(params) {
    request(api.listRegionDropDown(params)).then((data) => {
      setListRegions(data)
    })
  }

  // Api requests
  async function storeDistrict(data) {
    try {
      await request(api.storeDistrict(data))
      notification.success({
        description: getMessage('successStoreDistrict'),
        message: getMessage('sweetAlerts.success')
      })
      setFormValues({})
      history.goBack()
    } catch (error) {
      console.tron.log('error storeDistrict', error)
    }
  }

  async function retrieveDistrict(id) {
    try {
      const response = await request(api.retrieveDistrict(id))
      console.tron.log('response retrieveDistrict', response)
      setFormValues({ ...response })
    } catch (error) {
      console.tron.log('error retrieveDistrict', error)
    }
  }

  async function updateDistrict(payload) {
    try {
      console.tron.log('updateDistrict')
      const { id, data } = payload
      await request(api.updateDistrict(id, data))
      notification.success({
        description: getMessage('successUpdateDistrict'),
        message: getMessage('sweetAlerts.success')
      })
      history.goBack()
    } catch (error) {
      console.tron.log('error updateDistrict', error)
    }
  }

  function renderHeader(submitForm) {
    const hasAccess = id == null ? validRule(RULES.DISTRICT) : validRule(RULES.DISTRICT)

    return (
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <div className="default-header-buttons">
            <Button className="button-return" onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" className="default-back-icon" />
              {getMessage('back')}
            </Button>
            {hasAccess && (
              <Button type="primary" className="button-action" onClick={submitForm}>
                {id ? getMessage('update') : getMessage('register')}
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  function getTitle() {
    return id != null ? getMessage('updateDistrict') : getMessage('createDistrict')
  }

  return (
    <>
      <Formik
        enableReinitialize
        validationSchema={!id ? form.yupValidationCreate : form.yupValidationUpdate}
        initialValues={formValues}
        onSubmit={(values, { setSubmitting, setFieldError, resetForm }) =>
          form.onSubmit(values, setSubmitting, setFieldError, resetForm)
        }
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, errors, handleBlur, handleSubmit, setFieldValue, submitForm }) => {
          const setFieldValueWithState = (field, value) => {
            setFormValues({ ...formValues, [field]: value })
            return setFieldValue(field, value)
          }

          return (
            <Form className="district-form" layout={formLayout} onSubmit={handleSubmit}>
              {renderHeader(submitForm)}

              <Card className="ant-card gx-card ant-card-bordered">
                <Typography.Title className="default-header-title" level={3}>
                  {getTitle()}
                </Typography.Title>

                <Row type="flex" justify="start">
                  <CustomSwitch
                    field="active"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={12}
                    value={values}
                    handleBlur={handleBlur}
                    unCheckedChildren={getMessage('label.inactive')}
                    checkedChildren={getMessage('label.active')}
                  />
                </Row>
                <Row style={{ display: 'flex', flexDirection: 'row', marginLeft: '-15px', paddingTop: '20px' }}>
                  <CustomSelect
                    label="Região"
                    placeholder="Selecione uma Região"
                    showSearch
                    field="regionId"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={6}
                    value={values}
                    values={listRegions}
                    onChange={(e) => setFormValues({ ...formValues, regionId: e })}
                  />
                  {/* <CustomSelect
                    showSearch
                    field="regionId"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={6}
                    value={values}
                    onChangeWithField={onChangeRegion}
                    values={formatedRegions}
                  /> */}
                  <CustomInput
                    labelInput="Distrito"
                    placeholder="Nome do distrito"
                    field="name"
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={8}
                    value={values}
                    handleBlur={handleBlur}
                  />
                </Row>
              </Card>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}

export default CreateDistrict
